import { TimelineEnum } from '../enums/timeline-enum';
import { AccountRoles } from '../../shared/constants/account-roles.enum';

export class TimelineHelper {
  static getTimelineTranslationKey(timeline: number, role: string) {
    role = role.toLowerCase();
    switch (timeline) {
      case TimelineEnum.RequestListed:
        if (role === AccountRoles.Shipper) {
          return 'Timeline_RequestListed';
        } else if (role === AccountRoles.Carrier) {
          return 'Timeline_ReviewDeal';
        } else {
          return 'Timeline_RequestListed';
        }
      case TimelineEnum.ReviewDeal:
        if (role === AccountRoles.Shipper) {
          return 'Timeline_ReviewDeal';
        } else if (role === AccountRoles.Carrier) {
          return 'Timeline_AcceptancePending';
        } else {
          return 'Timeline_ReviewDeal';
        }
      case TimelineEnum.PaymentInProgress:
        return 'Timeline_PaymentInProgress';
      case TimelineEnum.PaymentCompleted:
        return 'Timeline_PaymentCompleted';
      case TimelineEnum.ShipmentCompleted:
        return 'Timeline_ShipmentCompleted';
    }
  }
}
